import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../authentication/authentication.service';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PermissionGuard implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService
    ) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    return this.authService.getUserClaims().pipe(
      map(claims => {
        const expectedRole = route.data.expectedRoles.find(x => claims.role);
        const deniedType = route.data.deniedPolicy;

        var deniedInfo;
        deniedType.forEach(element => {
          if (element.types.find(t => t == claims.type)) {
            deniedInfo = element;
          }
        });

        if (!expectedRole || deniedInfo) {
          if (route.params.pageMode && !deniedInfo.forPages.find(x => x == route.params.pageMode)) {
            return true;
          } else {
            this.translate.get('Error_NoPermissionToAccessThePage').subscribe(res => {
              this.toastr.warning(res);
            });
            this.navigateTo(deniedInfo.redirectTo);
            return false;
          }
        }

        return true;
      }));
  }

  private navigateTo(url: string) {
    if (url) {
      this.router.navigate([url]);
    } else {
      this.router.navigate(['/request/list']);
    }
  }
}
